import { render, staticRenderFns } from "./GridNameForm.vue?vue&type=template&id=72ca72d2&scoped=true&"
import script from "./GridNameForm.vue?vue&type=script&lang=js&"
export * from "./GridNameForm.vue?vue&type=script&lang=js&"
import style0 from "./GridNameForm.vue?vue&type=style&index=0&id=72ca72d2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72ca72d2",
  null
  
)

export default component.exports